import ShoppingNav from './shoppingNav';

export default ShoppingNav;